import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { CloseBtn } from "../svg/AllSvg";
import { dataActions } from "../../../shared/store/dataSlice";

const OtherWebLink = () => {
    const webOpen: boolean = useSelector((state: any) => state.data.webOpen);
    const link: string = useSelector((state: any) => state.data.link);
    const dispatch = useDispatch();
    const { t } = useTranslation('common');

    document.onkeydown = function (evt: any) {
        if (evt.keyCode === 27) {
            dispatch(dataActions.setWebOpen(false))
        }
    };

    const handleLink = () => {
        if (!!link) {
			if (link === "https://www.india.gov.in/") {
				window.open(link, '_blank', 'noopener,noreferrer,width=800,height=600');
			} else {
				window.open(link, '_blank');
			}
            dispatch(dataActions.setWebOpen(false));
            dispatch(dataActions.setLink(null));
        }
    }

    return (
        <>
            {webOpen &&
                <div className="fixed inset-0 z-[40] overflow-y-hidden top-0 ">
                    <div
                        className="fixed inset-0 w-full h-full bg-[rgba(216,216,216,0.60)] backdrop-blur-[15px]" onClick={() => dispatch(dataActions.setWebOpen(false))}
                    ></div>
                    <div className="flex justify-center items-center min-h-screen">
                        <div className="m-[15px] md:mx-auto bg-white rounded-[15px] w-full h-auto xsm:w-[400px] relative p-[24px] shadow-[0px_20px_24px_-4px_rgba(16,24,40_0.08),0px_8px_8px_-4px_rgba(16,24,40,0.03)]">
                            <img src={require('../../../assets/images/popup-bg.png')} alt="web-popup-bg" className="absolute top-0 left-0 right-0 bottom-0 w-full h-full rounded-[15px]" />

                            <button aria-label={t("aria_label.close")} title={t("aria_label.close")} className="absolute top-[15px] right-[15px] rounded-full min-w-[23px] h-[23px] flex items-center justify-center focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] z-[2]" onClick={() => dispatch(dataActions.setWebOpen(false))}>
                                <CloseBtn />
                            </button>

                            <div className="flex flex-col gap-[15px] xlx:gap-[20px] relative z-[1]">
                                <img src={require("../../../assets/images/web.png")} alt="web" className="w-fit h-fit ml-[-5px]" />
                                <h3 className="text-primaryText font-bold max-w-[432px] leading-snug">{t("website.title")}</h3>

                                <div className="flex items-center gap-[12px] mt-[15px] xlx:mt-[20px]">
                                    <button className="flex items-center justify-center px-[15px] bg-primary text-white uppercase text-sm font-bold tracking-wide min-h-[40px] gap-[10px] hover:shadow-[0_0_0_3px_#1b98525e] focus:shadow-[0_0_0_3px_#1b98525e] w-full whitespace-nowrap" autoFocus onClick={handleLink}>{t("website.yes")}</button>
                                    <button className="flex items-center justify-center px-[15px] bg-[#ABABAB] text-white uppercase text-sm font-bold tracking-wide min-h-[40px] gap-[10px] hover:shadow-[0_0_0_3px_#0000005e] focus:shadow-[0_0_0_3px_#0000005e] w-full whitespace-nowrap" onClick={() => dispatch(dataActions.setWebOpen(false))}>{t("website.no")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default OtherWebLink;